export const PSA_CHART_TYPES = {
  acBar: 'acBar',
  acRadial: 'acRadial',
  acPie: 'acPie',
  acLines: 'acLines',
  watchList: 'watchList',
  gauge: 'gauge',
}
